import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {UtmService} from './utm.service';
import {isPlatformBrowser} from '@angular/common';

declare let gtag: (...args: any[]) => void;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private readonly utm: UtmService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  /** Generic GA4 event sender with automatic UTM enrichment */
  public event(eventName: string, eventParams: Record<string, any> = {}): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const enriched = {
      ...eventParams,
      ...this.getUtmProps(),                // last-touch (utm_*, gclid, fbclid)
      ...this.getUtmProps('first'),  // first-touch namespaced (first_utm_*)
    };

    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, enriched);
    } else {
      console.warn('gtag not available', { eventName, enriched });
    }
  }

  public startTrial(plan: 'starter' | 'pro'): void {
    this.event('start_trial', {
      plan,
      value: plan === 'pro' ? 39.99 : 19.99,
      currency: 'EUR',
    });
  }

  public clickCta(
    ctaName: string,
    pageName: string,
  ): void {
    this.event('click_cta', {
      cta: ctaName,
      section: pageName,
    });
  }

  // ---- UTM helpers ----
  private getUtmProps(mode: 'last' | 'first' = 'last'): Record<string, any> {
    const bag = mode === 'last' ? this.utm.getLast() : this.utm.getFirst();
    if (!bag) return {};

    // last-touch: pass through standard keys so GA4 attribue naturellement
    if (mode === 'last') {
      const { ts, ...rest } = bag;
      return rest;
    }

    // first-touch: namespace to avoid overriding standard utm_* in GA
    const out: Record<string, any> = {};
    Object.entries(bag).forEach(([k, v]) => {
      if (k !== 'ts' && v) out[`first_${k}`] = v;
    });
    return out;
  }
}
